import { dispatcher } from 'dispatcher';

export default contactPreferences => dispatcher.dispatch('user:details:update', contactPreferences);
